import React from "react";

function BS4_ListGroups() {
  return (
    <div>
      <h1>BS4_ListGroups Component</h1>
      <p>This is the BS4_ListGroups tutorial page content.</p>
    </div>
  );
}

export default BS4_ListGroups;
